
// import * as common from './common';
import * as top from './top';
//import * as signatureshorts from './signatureshorts';

window.onload = function () {
   //読み込み終わり

   //   common.common()

   const mediaQueryList = matchMedia('(min-width:768px)');
   mediaQueryList.addListener(onMediaQueryChange);


   $('.movieWrapper a').on("click", function () {
      let movieUrl = $(this).attr('href');
      let movieTitle = $(this).parent().find('.postTitle').text();

      $(".movieModalWrapperInner iframe").attr("src", movieUrl);
      $('.movieModalTitle').text(movieTitle);

      $('body').addClass('nonScrollY');
      no_scroll();

      $('.iframeBack').fadeIn();
      $('.movieModalWrapper').fadeIn();

      return false;
   });


   $('.iframeBack, .closeWrapper').on("click", function () {
      $(".movieModalWrapperInner iframe").attr("src", "";
      $('.iframeBack').fadeOut();
      $('.movieModalWrapper').fadeOut();

      $('body').removeClass('nonScrollY');
      return_scroll()
   });

   //From VELページのmore動作
   if ($('body').hasClass('page-template-page-from_vel')) {
      //もっとみる
      var jQ_reply = $(".commentWrapper");

      jQ_reply.each(function () {
         if ($(this).find(".comment").length <= 5) {
            $(".reply-more").hide();
            return;
         } else {
            $(this).find(".comment").each(function (index) {
               if (index > 4) {
                  $(this).addClass("hide");
               }
            });
            $(this).next(".reply-more").on("click", function () {
               var hideCount = 0,
                  jQ_parent = $(this).prev(".commentWrapper"),
                  replyListItemLength = jQ_parent.find(".comment").length;

               jQ_parent.find(".comment").each(function (index) {
                  if (hideCount >= 5) {
                     return true;
                  }
                  if ($(this).hasClass("hide")) {
                     $(this).removeClass("hide");
                     hideCount++;
                  }
                  if (index + 1 >= replyListItemLength) {
                     jQ_parent.next(".reply-more").addClass("hide");
                  }
               });
            });
         }
      });
   }


   function onMediaQueryChange(mediaQueryList) {
      if (mediaQueryList.matches == true) {
         console.log("PC")
         // common.common_pc();


         if ($('body').hasClass('home')) {
            //top.top_common();
            top.top_pc();
         }


         let scroll_flag = false;
         let $window = $(window);

         $(window).scroll(function () {
            //headerのバック表示
            if ($window.scrollTop() > 100) {

               if (scroll_flag === false) {
                  $('header').addClass('backOn');

                  scroll_flag = true;
               }
            } else {
               $('header').removeClass('backOn');

               scroll_flag = false;
            }
         })
      } else {
         console.log("SP")
         // top.top_sp();

         let menuIconFlag = false;

         $(".menuIcon").on("click", function () {

            menuIconFlag = !menuIconFlag;

            if (menuIconFlag) {
               // $(".row-02-Outer").fadeIn();
               $('.contentsMenuWrapperOuter').addClass('contentsMenu--on');
               $('.menuIcon').addClass('menu--on');
               $('body').addClass('nonScrollY');

               //iOS用スクロールを不可能に。
               no_scroll();
            } else {
               // $(".row-02-Outer").fadeOut();
               $('.contentsMenuWrapperOuter').removeClass('contentsMenu--on');
               $('.menuIcon').removeClass('menu--on');
               $('body').removeClass('nonScrollY');

               //iOS用スクロールを可能に。
               return_scroll()
            }
         });
         // common.common_sp();
         if ($('body').hasClass('home')) {
            top.top_sp();
         }
      }
   }
   onMediaQueryChange(mediaQueryList);

   function no_scroll() {
      // PCでのスクロール禁止
      // document.addEventListener("mousewheel", scroll_control, { passive: false });
      // スマホでのタッチ操作でのスクロール禁止
      document.addEventListener("touchmove", scroll_control, { passive: false });
   }
   // スクロール禁止解除
   function return_scroll() {
      // PCでのスクロール禁止解除
      // document.removeEventListener("mousewheel", scroll_control, { passive: false });
      // スマホでのタッチ操作でのスクロール禁止解除
      document.removeEventListener('touchmove', scroll_control, { passive: false });
   }

   function scroll_control(event) {
      event.preventDefault();
   }
}

